var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2866,
    height: 766,
    viewBox: "0 0 2866 766",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1531.23 766V597.712H1480.33V766H1531.23ZM1683.94 766V597.712H1633.04V766H1683.94Z",
    fill: "#120740"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2492.5 766V597.712H2441.6V766H2492.5Z",
    fill: "#120740"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M820.255 597.712V766H769.352V597.712H820.255Z",
    fill: "#120740"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M718.452 766V597.712H565.744V766H718.452Z",
    fill: "#120740"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M452 598V766H424.012V598H452Z",
    fill: "#120740"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M396.024 766V598H312.061V766H396.024Z",
    fill: "#120740"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M169.32 766V598H90.6287V766H169.32Z",
    fill: "#120740"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9878 766V598H1V766H28.9878Z",
    fill: "#120740"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M259.244 766V598H231.256V766H259.244Z",
    fill: "#120740"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1881.75 597.712V766H1830.86V597.712H1881.75Z",
    fill: "#120740"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2065.34 766V681.856V597.712H1963.54V766H2065.34Z",
    fill: "#120740"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1217.06 766V597.712H1073.95V766H1217.06Z",
    fill: "#120740"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M985.796 766V597.712H934.893V766H985.796Z",
    fill: "#120740"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1348.68 766V597.712H1297.78V766H1348.68Z",
    fill: "#120740"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2247.39 766V597.712H2196.49V766H2247.39Z",
    fill: "#120740"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2355.16 766V597.712H2304.26V766H2355.16Z",
    fill: "#120740"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2638.56 766V597.712H2587.66V766H2638.56Z",
    fill: "#120740"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2865.41 766V597.712H2814.51V766H2865.41Z",
    fill: "#120740"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2751.99 766V597.712H2701.09V766H2751.99Z",
    fill: "#120740"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6946 439.638V0H0V439.638H52.6946ZM52.6946 0L168.911 439.638H223.771L108.276 0H52.6946ZM448.265 439.638V0H395.57V439.638H448.265ZM223.771 439.638H279.353L395.57 0H339.988L223.771 439.638Z",
    fill: "#120740"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1781.58 281.805C1781.58 190.36 1706.48 116.061 1614.04 116.061C1522.33 116.061 1447.22 190.36 1447.22 281.805C1447.22 373.249 1522.33 446.834 1614.04 446.834C1678.32 446.834 1736.09 411.827 1764.25 353.96L1717.31 331.099C1697.81 370.391 1658.09 395.396 1614.04 395.396C1555.55 395.396 1507.16 351.102 1500.66 294.664H1781.58V281.805ZM1505.71 248.227C1520.16 201.79 1562.77 168.213 1614.04 168.213C1665.32 168.213 1708.65 201.79 1723.09 248.227H1505.71Z",
    fill: "#120740"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M836.363 281.805C836.363 190.36 761.258 116.061 668.821 116.061C577.105 116.061 502 190.36 502 281.805C502 373.249 577.105 446.834 668.821 446.834C733.098 446.834 790.871 411.827 819.031 353.96L772.092 331.099C752.592 370.391 712.872 395.396 668.821 395.396C610.327 395.396 561.941 351.102 555.443 294.664H836.363V281.805ZM560.494 248.227C574.937 201.79 617.546 168.213 668.821 168.213C720.096 168.213 763.426 201.79 777.869 248.227H560.494Z",
    fill: "#120740"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M2003.11 116.061C1956.16 116.061 1915 139.636 1891.17 175.357V123.205H1838.45V439.689H1891.17V265.373C1891.17 213.221 1934.5 169.642 1987.94 169.642C2040.66 169.642 2084.71 213.221 2084.71 265.373V439.689H2138.88V250.37C2138.88 176.786 2077.49 116.061 2003.11 116.061Z",
    fill: "#120740"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2301.63 34.8181H2243.5V383H2301.63V34.8181Z",
    fill: "#120740"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M2301.63 116.061H2359.75V174.091H2301.63V116.061Z",
    fill: "#120740"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2185.38 116.061H2243.5V174.091H2185.38V116.061Z",
    fill: "#120740"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M2301.63 383H2359.75V441.03H2301.63V383Z",
    fill: "#120740"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2499.25 121.864H2441.12V441.03H2499.25V121.864Z",
    fill: "#120740"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2441.12 0H2499.25V63.8333H2441.12V0Z",
    fill: "#120740"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1273.73 116.061C1311.88 116.061 1341.51 127.31 1362.6 149.808C1384.15 171.889 1394.92 202.719 1394.92 242.299V441.03H1337.02V248.549C1337.02 220.218 1330.06 198.553 1316.14 183.555C1302.23 168.14 1282.03 160.432 1255.55 160.432C1228.61 160.432 1207.74 168.972 1192.93 186.054C1178.12 202.719 1170.71 225.426 1170.71 254.173V441.03H1114.15V248.549C1114.15 219.801 1107.19 197.928 1093.28 182.93C1079.81 167.931 1059.84 160.432 1033.35 160.432C1006.87 160.432 985.773 168.556 970.057 184.805C954.8 201.053 947.169 223.968 947.169 253.548V441.03H889.262V120.435H939.09L945.146 218.551C950.534 181.888 962.205 155.64 980.159 139.809C998.112 123.977 1021.91 116.061 1051.53 116.061C1081.16 116.061 1105.39 123.768 1124.25 139.184C1143.55 154.599 1156.57 181.055 1163.3 218.551C1169.58 182.305 1182.16 156.265 1201 140.434C1219.86 124.185 1244.1 116.061 1273.73 116.061Z",
    fill: "#120740"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M2580.62 121.864H2644.56V185.697H2580.62V121.864Z",
    fill: "#120740"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M2865.4 121.864H2801.46V185.697H2865.4V121.864Z",
    fill: "#120740"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M2627.11 185.697H2691.05V249.53H2627.11V185.697Z",
    fill: "#120740"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M2627.11 313.364H2691.05V377.197H2627.11V313.364Z",
    fill: "#120740"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M2818.91 313.364H2754.97V377.197H2818.91V313.364Z",
    fill: "#120740"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M2580.62 377.197H2644.56V441.03H2580.62V377.197Z",
    fill: "#120740"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M2865.4 377.197H2801.46V441.03H2865.4V377.197Z",
    fill: "#120740"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M2818.91 185.697H2754.97V249.53H2818.91V185.697Z",
    fill: "#120740"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M2673.6 249.53H2772.41V313.364H2673.6V249.53Z",
    fill: "#120740"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3b7a46fcea40b2adb7cb9de9f1fef819.svg";
export { ForwardRef as ReactComponent };